import { FC, ReactNode } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";
import { sharedProps } from "~/constants";

interface Props extends FlexProps {
  children: ReactNode;
}

export const MaxContentSection: FC<Props> = ({ children, ...props }) => (
  <Flex direction="column" {...sharedProps.max.content} {...props}>
    {children}
  </Flex>
);
